<template>
  <div :style="styleObject">
    <button
      style="display: none"
      type="button"
      class="btn-show-item-detail-modal"
      data-bs-toggle="modal"
      data-bs-target="#modal_item_detail"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-item-detail-modal"
      data-bs-target="#modal_item_detail"
      data-bs-dismiss="modal"
    ></button>
    <div
      class="modal modal-full fade"
      id="modal_item_detail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_item_detail"
      style="z-index: 10000"
    >
      <div class="btn-close-modal" @click="closeModel()">
        <div>&times;</div>
      </div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body" style="padding: 0px;" v-on:scroll.passive='handleScroll($event)'>
            <div class="page-header align-items-start" v-if="isLoadDone">
              <div class="container">
                <div class="content">
                  <div class="item-img-container">
                    <div class="image-container">
                      <img
                        v-if="itemInfo.image && !imageError"
                        ref="foodImage"
                        :src="itemInfo.image"
                        alt="Food Image"
                        class="food-image"
                        @error="imageError = true"
                      >
                      <div v-else ref="foodImage" class="food-image food-image--placeholder">
                        <i class="material-icons-round food-image__placeholder-icon">restaurant</i>
                      </div>
                    </div>
                    <div class="content-sheet pad-left-right" style="display: flex; align-items: flex-start;">
                      <div class="item-name" style="width: 70%; line-height: normal">
                        {{ tName(itemInfo.item_name) }}
                      </div>
                      <div style="width: 2%;"></div>
                      <div class="item-name" style="width: 28%;text-align: right;display: grid;justify-content: end;">
                        <span style="line-height: normal;font-size: 16px;margin-top: 3.5px;">${{ isLogined ? (itemInfo.member_price ? (itemInfo.member_price * itemInfo.quantity).toFixed(2) : "0.00") : (itemInfo.price_default ? (itemInfo.price_default * itemInfo.quantity).toFixed(2) : "0.00") }}</span>
                        <!-- KSK119: the usual price struck through while a price schedule sells it lower. -->
                        <span v-if="scheduleRegularTotal" class="schedule-struck">${{ scheduleRegularTotal.toFixed(2) }}</span>
                      </div>
                    </div>
                    <div class="item-description fs-11 w-100 mt-1 pad-left-right">
                      {{ subLine(itemInfo) }}
                    </div>
                    <div class="detail-divider"></div>
                  </div>
                  <div class="choice mt-3 pad-left-right" v-if="itemInfo.choice">
                    <div v-if="!itemInfo.is_sub_category" class="choice-list mt-1 fs-13 font-weight-bold">
                      <div
                        v-for="(choice, index) in itemInfo.choices"
                        :key="index"
                        :class="['choice-tab', 'choice-' + index, { active: index == selectedChoiceIndex }]"
                        @click="selectChoice(index)"
                      >{{ tName(choice.name) }}</div>
                    </div>
                    <div class="item-list">
                      <!-- Sub-category: choose ONE item; its modifiers open in a modal -->
                      <template v-if="itemInfo.is_sub_category">
                        <div
                          class="item-detail subcat-item"
                          :class="{
                            'subcat-selected': selectedSubCategoryIndex === indexChoice,
                            'modifier-not-available': !isSubCategoryItemAvailable(item),
                          }"
                          v-for="(item, indexChoice) in choiceSelected.items"
                          :key="indexChoice"
                          @click="selectSubCategoryItem(indexChoice)"
                        >
                          <div v-if="item.item_detail" class="item-img-container">
                            <div class="mt-3 pad-left-right" style="display: flex; align-items: flex-start;">
                              <i class="material-icons-round opacity-10 cursor-pointer" style="color: var(--color); font-size: 20px; margin-right: 6px;">
                                {{ selectedSubCategoryIndex === indexChoice ? 'radio_button_checked' : 'radio_button_unchecked' }}
                              </i>
                              <div class="item-name" style="width: 70%; line-height: normal;">
                                {{ item.qty + ' x ' + tName(item.item_detail.item_name) }}
                              </div>
                              <div class="item-name text-end" style="width: 30%; line-height: normal; font-size: 13px; margin-top: 3.5px; color: var(--color);">
                                ${{ isLogined ? parseFloat(item.item_detail.member_price || item.item_detail.price_default || 0).toFixed(2) : parseFloat(item.item_detail.price_default || 0).toFixed(2) }}
                              </div>
                            </div>
                            <div class="item-description fs-11 w-100 mt-1 pad-left-right">
                              {{ item.item_detail.description }}
                            </div>
                            <!-- Preview of selected modifiers (no need to reopen modal) -->
                            <div
                              v-if="selectedSubCategoryIndex === indexChoice && selectedModifierList(item.item_detail).length"
                              class="subcat-mod-summary pad-left-right"
                            >
                              <div
                                v-for="(mod, mi) in selectedModifierList(item.item_detail)"
                                :key="mi"
                                class="subcat-mod-line"
                                :class="{ nested: mod.nested }"
                              >
                                <span class="subcat-mod-name">{{ mod.quantity }} x {{ tName(mod.name) }}</span>
                                <span v-if="mod.price > 0" class="subcat-mod-price">
                                  +${{ (mod.price * mod.quantity).toFixed(2) }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!-- Normal choice: inline modifiers for every item -->
                      <template v-else>
                        <div class="item-detail" v-for="(item, indexChoice) in choiceSelected.items" :key="indexChoice">
                          <div v-if="item.item_detail" class="item-img-container">
                            <div class="mt-3 pad-left-right" style="display: flex; align-items: flex-start;">
                              <div class="item-name" style="width: 70%; line-height: normal;">
                                {{ item.qty + ' x ' + tName(item.item_detail.item_name) }}
                              </div>
                            </div>
                            <div class="item-description fs-11 w-100 mt-1 pad-left-right">
                              {{ item.item_detail.description }}
                            </div>
                            <item-modifier
                              :key="'choice-' + reloadModal + '-' + indexChoice"
                              :keyReload="itemModifierKey"
                              :itemInfo="item.item_detail"
                              :selectOnlyItem="selectOnlyItemChoice"
                              :selectMultiItem="selectMultiItemChoice"
                              :removeModifierOptionGroup="removeModifierOptionGroupChoice"
                              :addModifierOptionGroup="addModifierOptionGroupChoice"
                              :indexChoice="indexChoice"
                            >
                            </item-modifier>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="banner mt-3 pad-left-right" v-if="itemInfo.slides && itemInfo.slides.length">
                    <swiper
                      :slides-per-view="1"
                      :space-between="0"
                      :loop="true"
                      :autoplay="{
                        delay: 3000,
                        disableOnInteraction: false,
                      }"
                      :pagination="{
                        clickable: true,
                        el: '.swiper-pagination',
                      }"
                    >
                      <swiper-slide v-for="(value, index) in itemInfo.slides" :key="index">
                        <div class="slider" @click="clickLink(value)" style="position: relative;display: flex; align-items: center; justify-content: center;">
                          <div v-if="value.direct_to_suggested_adds_on == 1 && value.itemSelected" style="position: absolute;width: 90%;height: 90%;align-items: center;display: flex;">
                            <div style="width: 100%;height: 80%;display: inline-flex;gap:2%;">
                              <div style="width: 49%;height: 100%;">
                                <img
                                  :src=value.itemSelected.image
                                  alt="error"
                                  style="height: 100%;"
                                />
                              </div>
                              <div style="width: 49%">
                                <div style="background: gray;color:white;padding-left: 10px;">
                                  <div>{{ $t('itemDetail.addsOn', { price: '$' + value.itemSelected.price }) }}</div>
                                </div>
                                <div style="background: gray;color:white;margin-top:5px;padding-left: 10px;">
                                  <div>{{ tName(value.itemSelected.item_name) }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <img
                            :src=value.file_url
                            alt="error"
                          />
                        </div>
                      </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination"></div>
                  </div>

                  <div v-if="itemInfo.bundle_item && itemInfo.bundle_item.length" style="margin-top: 20px;margin-bototm: 20px;">
                    <div
                      v-for="(bundleItem, index) in itemInfo.bundle_item"
                      :key="index"
                    >
                    <div style="display:table;width:100%;margin-top:8px;" class="pad-left-right">
                      <div style="display:table-cell;width:auto;">
                        <strong>{{ bundleItem.itemName }} </strong>
                        <br>{{ bundleItem.description }}
                      </div>
                      <div style="width:70px;display:table-cell;vertical-align:top; padding:5px;">
                        &nbsp;x&nbsp;<strong>{{ bundleItem.quantity }}</strong>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <!-- <div class="break-line" style="margin-top: 20px;" v-if="itemInfo.modifier_group && itemInfo.modifier_group.length > 0"></div> -->
                  <!-- <div class="highlight-banner">
                    <div>
                      <img
                        src="https://t3.ftcdn.net/jpg/04/75/78/56/360_F_475785604_HDtTcxBFA0Av87F7JoFmpircCcatQ22b.jpg"
                        alt="error"
                      />
                    </div>
                    <div>
                      <img
                        src="https://t3.ftcdn.net/jpg/04/75/78/56/360_F_475785604_HDtTcxBFA0Av87F7JoFmpircCcatQ22b.jpg"
                        alt="error"
                      />
                    </div>
                    <div>
                      <img
                        src="https://t3.ftcdn.net/jpg/04/75/78/56/360_F_475785604_HDtTcxBFA0Av87F7JoFmpircCcatQ22b.jpg"
                        alt="error"
                      />
                    </div>
                    <div>
                      <img
                        src="https://t3.ftcdn.net/jpg/04/75/78/56/360_F_475785604_HDtTcxBFA0Av87F7JoFmpircCcatQ22b.jpg"
                        alt="error"
                      />
                    </div>
                  </div> -->
                  <div v-if="!itemInfo.choice">
                    <item-modifier
                      :key="'main-' + reloadModal"
                      :keyReload="itemModifierKey"
                      :itemInfo="itemInfo"
                      :selectOnlyItem="selectOnlyItem"
                      :selectMultiItem="selectMultiItem"
                      :removeModifierOptionGroup="removeModifierOptionGroup"
                      :addModifierOptionGroup="addModifierOptionGroup"
                    >
                    </item-modifier>
                  </div>
                </div>
                <div class="add-to-cart">
                  <div class="total-item" style="width: 118px !important; flex: 0 0 auto;">
                    <div class="d-flex align-items-center" style="width: 100%;">
                      <i
                        style="width: 30%;text-align: left;font-size: 22px;"
                        class="material-icons-round opacity-10 cursor-pointer"
                        @click="itemInfo.quantity > 1 ? removeItem() : null"
                        >remove</i
                      >
                      <div class="item-quantity" style="width: 40%;">{{ itemInfo.quantity }}</div>
                      <i
                        style="width: 30%;text-align: right;font-size: 22px;"
                        class="material-icons-round opacity-10 cursor-pointer"
                        @click="addItem()"
                        >add</i
                      >
                    </div>
                  </div>
                  <div style="width: 10px; flex: 0 0 auto;"></div>
                  <material-button style="flex: 1 1 auto;" class="btn-add-to-cart" :class="{ 'disable': itemInfo.disable_add_to_cart }" @click="addToCart()">
                    <span class="btn-add-to-cart__label">{{ $t('itemDetail.addToCart') }}</span>
                    <span class="btn-add-to-cart__total">${{ isLogined ? (itemInfo.member_price ? (itemInfo.member_price * itemInfo.quantity).toFixed(2) : "0.00") : (itemInfo.price_default ? (itemInfo.price_default * itemInfo.quantity).toFixed(2) : "0.00") }}</span>
                  </material-button>
                </div>
              </div>
            </div>
            <material-loading :active="loaderActive" />
          </div>
        </div>
        <div class="item-name-top">
          <div>{{ tName(itemInfo.item_name) }}</div>
        </div>
      </div>
    </div>

    <ModalSubCategoryModifier
      :show="showSubCategoryModal"
      :item="selectedSubCategoryItemDetail || {}"
      @confirm="confirmSubCategoryModal"
      @cancel="cancelSubCategoryModal"
    >
      <div class="subcat-modal-body">
        <div
          v-if="selectedSubCategoryItemDetail && selectedSubCategoryItemDetail.image"
          class="item-img-container"
        >
          <div class="image-container">
            <img
              :src="selectedSubCategoryItemDetail.image"
              alt="Food Image"
              class="food-image"
            />
          </div>
        </div>
        <item-modifier
          v-if="selectedSubCategoryItemDetail"
          :key="'subcat-' + reloadModal + '-' + selectedSubCategoryIndex"
          :keyReload="itemModifierKey"
          :itemInfo="selectedSubCategoryItemDetail"
          :selectOnlyItem="selectOnlyItemChoice"
          :selectMultiItem="selectMultiItemChoice"
          :removeModifierOptionGroup="removeModifierOptionGroupChoice"
          :addModifierOptionGroup="addModifierOptionGroupChoice"
          :indexChoice="selectedSubCategoryIndex"
        >
        </item-modifier>
      </div>
    </ModalSubCategoryModifier>
  </div>
</template>

<script>
import OrderService from "../services/order.service";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import EventBus from "vue3-eventbus";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { localStorageName, getDiningOption, scrollToFirstInvalid } from '@/config/utils';
import ItemModifier from './components/ItemModifier.vue';
import ModalSubCategoryModifier from '@/components/ModalSubCategoryModifier.vue';
import { translatedName } from '@/i18n/menuTranslate';
import { scheduleOriginalPrice } from '@/config/specialPrice';

SwiperCore.use([Pagination, Autoplay]);

export default {
  name: "Customization",
  components: {
    MaterialButton,
    MaterialLoading,
    Swiper,
    SwiperSlide,
    ItemModifier,
    ModalSubCategoryModifier,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    itemDetail: {
      type: Object,
      required: true,
    },
    isLogined: {
      type: Boolean,
      default: false,
    },
    reloadModal: {
      type: String,
      required: true,
    },

    editMode: {
      type: Boolean,
      default: false,
    },
    editItemIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      isLoadDone: false,
      imageError: false,
      loaderActive: false,
      merchantCode: "",
      branchCode: "",
      branch: JSON.parse(localStorage.getItem(localStorageName('BRANCH_INFO'), '')),
      itemInfo: {},
      disableBtnAddToCart: false,
      getModifierToShowSlideSelected: [],
      cartName: 'ORDER_INFO',
      reloadModal1: 'reload-item-detail',
      originalChoices: [],
      choiceSelected: {},
      selectedChoiceIndex: 0,
      itemModifierKey: "itemModifierKey",
      // Sub-category single-select state
      selectedSubCategoryIndex: -1,
      showSubCategoryModal: false,
      subCategoryModalSnapshot: null,
    };
  },
  async created() {
    this.cartName = await this.$store.dispatch('cartName');
    const routeName = this.$route.name;

    if (routeName == 'Queue') {
      this.cartName = this.cartName.replace('ORDER_INFO_', 'ORDER_QUEUE_INFO_');
    }
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.closeModel(true));
  },
  computed: {
    // KSK119 on MOO / QR: the total at the usual base price (same modifiers / quantity) while a
    // price schedule sells the item - or the picked choice - lower; 0 otherwise. A member's usual
    // price is their member price.
    scheduleRegularTotal() {
      if (!this.itemInfo) return 0;
      const original = scheduleOriginalPrice(this.itemInfo, this.isLogined);
      if (!original) return 0;
      const unit = parseFloat(this.isLogined ? this.itemInfo.member_price : this.itemInfo.price_default) || 0;
      const base = parseFloat(this.isLogined
        ? this.itemInfo.member_price_no_modifier_option
        : this.itemInfo.price_default_no_modifier_option) || 0;
      const total = (unit + original - base) * (this.itemInfo.quantity || 1);
      return total > unit * (this.itemInfo.quantity || 1) ? total : 0;
    },
    styleObject() {
      const base =
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a";
      return {
        "--color": base,
        "--theme-20": this.blendWhite(base, 0.2),
        // --theme-30 mirrors Order.vue's page background (blendWhite 0.0675) so the
        // item-detail modal shares the exact same surface colour as the menu.
        "--theme-30": this.blendWhite(base, 0.0675),
        "--theme-40": this.blendWhite(base, 0.4),
        // Unselected modifier option rows sit between the panel (--theme-30) and
        // the selected state (--theme-20) — they need their own step, otherwise
        // they either vanish into the panel or read as already selected.
        "--theme-option": this.blendWhite(base, 0.11),
      };
    },
    // item_detail of the currently selected sub-category item (for the modal).
    selectedSubCategoryItemDetail() {
      if (!this.itemInfo.is_sub_category) return null;
      const idx = this.selectedSubCategoryIndex;
      const items = this.choiceSelected && this.choiceSelected.items;
      if (idx < 0 || !items || !items[idx]) return null;
      return items[idx].item_detail || null;
    },
  },
  methods: {
    // Item / choice / modifier names translated for display only.
    tName(source) {
      return translatedName(source);
    },

    // Second line under the item name: the ENGLISH source name while a foreign
    // language is displayed, the merchant description on English. Mirrors the
    // menu list so the detail sheet reads the same way.
    subLine(item) {
      if (this.$i18n.locale !== "en") {
        return item.item_name || item.name || "";
      }
      return item.description || "";
    },

    blendWhite(color, ratio) {
      // Accept #rrggbb, #rgb, or rgb()/rgba() — the merchant-admin colour picker
      // may persist any of these. Only bail if we truly can't parse it.
      if (typeof color !== "string") return color;
      const s = color.trim();
      let r, g, b, m;
      if ((m = s.match(/^#([0-9a-fA-F]{6})$/))) {
        r = parseInt(m[1].slice(0, 2), 16);
        g = parseInt(m[1].slice(2, 4), 16);
        b = parseInt(m[1].slice(4, 6), 16);
      } else if ((m = s.match(/^#([0-9a-fA-F]{3})$/))) {
        r = parseInt(m[1][0] + m[1][0], 16);
        g = parseInt(m[1][1] + m[1][1], 16);
        b = parseInt(m[1][2] + m[1][2], 16);
      } else if ((m = s.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i))) {
        r = +m[1];
        g = +m[2];
        b = +m[3];
      } else {
        return color;
      }
      const mix = (c) => Math.round(ratio * c + (1 - ratio) * 255);
      const h = (v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0");
      return "#" + h(mix(r)) + h(mix(g)) + h(mix(b));
    },
    // fly-to-cart payload for the item-detail modal add: the food image's
    // viewport rect + url, consumed by Order.vue's runFlyToCart via EventBus.
    getFlyPayload() {
      const el = this.$refs.foodImage;
      if (!el || typeof el.getBoundingClientRect !== "function") {
        return { originRect: null, imageUrl: this.itemInfo?.image || "" };
      }
      return {
        originRect: el.getBoundingClientRect(),
        imageUrl: this.itemInfo?.image || "",
      };
    },
    // KSK119 for choices: the picked choice's usual prices (from item-detail), struck through
    // next to its scheduled price like a Main Item.
    applyChoiceSchedule() {
      this.itemInfo.original_price = this.choiceSelected ? this.choiceSelected.original_price : undefined;
      this.itemInfo.original_member_price = this.choiceSelected ? this.choiceSelected.original_member_price : undefined;
    },
    formatPrice(price) {
        return '$ ' + parseFloat(price).toFixed(2);
    },
    closeModel(isPopState = false) {
      if (!isPopState) {
        this.$emit('clear-data-item');
      }
      
      $(".btn-hide-item-detail-modal").click();
    },

    handleScroll(event) {
      var scrollTop = event.srcElement.scrollTop;
      var scrollMax = 16 + $('.item-image').height() + 16;
      
      if (scrollTop >= scrollMax) {
        $('.item-name-top').addClass('active');
      } else {
        if (scrollTop < scrollMax) {
          $('.item-name-top').removeClass('active');
        }
      }
    },

    showHideModifier(index) {
      if (this.itemInfo.modifier_group[index]) {
        if (this.itemInfo.modifier_group[index].is_show) {
          this.itemInfo.modifier_group[index].is_show = false;
        } else {
          this.itemInfo.modifier_group.forEach((item, idx) => {
            this.itemInfo.modifier_group[idx].is_show = false;
          })

          this.itemInfo.modifier_group[index].is_show = true;
        }
      }
    },

    selectChoice(index) {
      this.itemModifierKey = Math.random();

      // Save current choice's modifier state back to originalChoices before switching
      const originalChoices = JSON.parse(this.originalChoices);
      if (this.choiceSelected && this.choiceSelected.items) {
        originalChoices[this.selectedChoiceIndex] = JSON.parse(JSON.stringify(this.choiceSelected));
      }
      this.originalChoices = JSON.stringify(originalChoices);

      // Switch to the new choice
      this.selectedChoiceIndex = index;
      this.choiceSelected = originalChoices[index];

      // Sub-category: single-select behaviour — default to the lowest-price item
      // and derive the price from that item only (not the sum of all items).
      if (this.itemInfo.is_sub_category) {
        this.defaultSelectLowestSubCategory();
        this.checkAvailableAddToCart();
        return;
      }

      $('.choice-list > .choice-tab').removeClass('active');
      $('.choice-list > .choice-' + index).addClass('active');

      this.itemInfo.price_default_no_modifier_option = this.choiceSelected.default_price;
      this.itemInfo.price_default = this.choiceSelected.default_price;
      this.itemInfo.member_price_no_modifier_option = this.choiceSelected.member_price;
      this.itemInfo.member_price = this.choiceSelected.member_price;
      this.applyChoiceSchedule();

      // Ensure required modifier groups have defaults BEFORE calculating price
      if (this.choiceSelected.items) {
        this.choiceSelected.items.forEach((choiceItem) => {
          if (choiceItem.item_detail && choiceItem.item_detail.modifier_group) {
            this.ensureDefaultForRequiredGroups(
              choiceItem.item_detail.modifier_group
            );
          }
        });
      }

      // Recalculate price including selected + default modifiers
      this.recalcChoiceModifierPrice();

      this.checkAvailableAddToCart();
    },

    recalcChoiceModifierPrice() {
      if (!this.choiceSelected || !this.choiceSelected.items) return;

      let totalModifierPrice = 0;
      this.choiceSelected.items.forEach((choiceItem) => {
        if (!choiceItem.item_detail || !choiceItem.item_detail.modifier_group) return;
        const itemChoiceQty = choiceItem.qty || 1;

        choiceItem.item_detail.modifier_group.forEach((group) => {
          group.items.forEach((modifierItem) => {
            if (modifierItem.selected) {
              totalModifierPrice +=
                (modifierItem.price_default || 0) *
                (modifierItem.quantity || 1) *
                itemChoiceQty;

              // Nested modifiers (item_in_mog)
              if (modifierItem.item_in_mog && modifierItem.item_in_mog.modifier_group) {
                modifierItem.item_in_mog.modifier_group.forEach((subGroup) => {
                  subGroup.items.forEach((subItem) => {
                    if (subItem.selected) {
                      totalModifierPrice +=
                        (subItem.price_default || 0) *
                        (subItem.quantity || 1) *
                        (modifierItem.quantity || 1) *
                        itemChoiceQty;
                    }
                  });
                });
              }
            }
          });
        });
      });

      this.itemInfo.price_default += totalModifierPrice;
      this.itemInfo.member_price += totalModifierPrice;
    },

    // ---- Sub-category single-select helpers ----
    isSubCategoryItemAvailable(choiceItem) {
      const d = choiceItem && choiceItem.item_detail;
      if (!d) return false;
      if (d.stock_enable_balance) return d.stock_balance > 0;
      return !d.is_not_available;
    },

    // Flatten the selected modifiers (incl. nested) of a sub-category item so we
    // can preview them under the selected item without opening the modal.
    selectedModifierList(itemDetail) {
      const result = [];
      if (!itemDetail || !Array.isArray(itemDetail.modifier_group)) return result;
      itemDetail.modifier_group.forEach((group) => {
        if (!Array.isArray(group.items)) return;
        group.items.forEach((it) => {
          if (!it.selected) return;
          result.push({
            name: it.item_name,
            quantity: it.quantity || 1,
            price: it.price_default || 0,
            nested: false,
          });
          if (it.item_in_mog && Array.isArray(it.item_in_mog.modifier_group)) {
            it.item_in_mog.modifier_group.forEach((sg) => {
              if (!Array.isArray(sg.items)) return;
              sg.items.forEach((si) => {
                if (!si.selected) return;
                result.push({
                  name: si.item_name,
                  quantity: si.quantity || 1,
                  price: si.price_default || 0,
                  nested: true,
                });
              });
            });
          }
        });
      });
      return result;
    },

    // Recompute itemInfo price from the currently selected sub-category item only
    // (its base price for the current login state + its selected modifiers).
    recalcSubCategoryPrice() {
      const idx = this.selectedSubCategoryIndex;
      const items = this.choiceSelected && this.choiceSelected.items;

      if (idx < 0 || !items || !items[idx] || !items[idx].item_detail) {
        this.itemInfo.price_default_no_modifier_option = 0;
        this.itemInfo.member_price_no_modifier_option = 0;
        this.itemInfo.price_default = 0;
        this.itemInfo.member_price = 0;
        return;
      }

      const choiceItem = items[idx];
      const itemDetail = choiceItem.item_detail;
      const qty = choiceItem.qty || 1;

      const baseDefault = parseFloat(itemDetail.price_default || 0);
      const baseMember = parseFloat(
        itemDetail.member_price || itemDetail.price_default || 0
      );

      this.itemInfo.price_default_no_modifier_option = baseDefault * qty;
      this.itemInfo.member_price_no_modifier_option = baseMember * qty;
      // Keep choiceSelected base in sync for downstream (compareObjects / cart).
      this.choiceSelected.default_price = baseDefault * qty;
      this.choiceSelected.member_price = baseMember * qty;

      let mods = 0;
      if (Array.isArray(itemDetail.modifier_group)) {
        itemDetail.modifier_group.forEach((group) => {
          if (!Array.isArray(group.items)) return;
          group.items.forEach((mItem) => {
            if (!mItem.selected) return;
            mods += (mItem.price_default || 0) * (mItem.quantity || 1) * qty;
            if (mItem.item_in_mog && Array.isArray(mItem.item_in_mog.modifier_group)) {
              mItem.item_in_mog.modifier_group.forEach((sg) => {
                if (!Array.isArray(sg.items)) return;
                sg.items.forEach((sItem) => {
                  if (!sItem.selected) return;
                  mods +=
                    (sItem.price_default || 0) *
                    (sItem.quantity || 1) *
                    (mItem.quantity || 1) *
                    qty;
                });
              });
            }
          });
        });
      }

      this.itemInfo.price_default =
        this.itemInfo.price_default_no_modifier_option + mods;
      this.itemInfo.member_price =
        this.itemInfo.member_price_no_modifier_option + mods;
    },

    // Default-select the lowest-price available sub-category item (no modal).
    defaultSelectLowestSubCategory() {
      const items = this.choiceSelected && this.choiceSelected.items;
      if (!Array.isArray(items) || !items.length) return;

      let lowestIdx = -1;
      let lowestPrice = Infinity;
      items.forEach((it, i) => {
        if (!it.item_detail || !this.isSubCategoryItemAvailable(it)) return;
        const p = this.isLogined
          ? parseFloat(it.item_detail.member_price || it.item_detail.price_default || 0)
          : parseFloat(it.item_detail.price_default || 0);
        if (p < lowestPrice) {
          lowestPrice = p;
          lowestIdx = i;
        }
      });
      if (lowestIdx === -1) lowestIdx = 0;

      this.selectedSubCategoryIndex = lowestIdx;
      this.recalcSubCategoryPrice();
    },

    // User picks a sub-category item: select it and open its modifiers modal (if any).
    selectSubCategoryItem(index) {
      const items = this.choiceSelected && this.choiceSelected.items;
      if (!items || !items[index] || !items[index].item_detail) return;
      if (!this.isSubCategoryItemAvailable(items[index])) return;

      this.selectedSubCategoryIndex = index;
      this.itemModifierKey = Math.random();
      this.recalcSubCategoryPrice();
      this.checkAvailableAddToCart();

      const itemDetail = items[index].item_detail;
      const hasModifiers =
        Array.isArray(itemDetail.modifier_group) &&
        itemDetail.modifier_group.length > 0;

      if (hasModifiers) {
        // Snapshot so Cancel reverts modifier changes made inside the modal.
        this.subCategoryModalSnapshot = {
          itemInfo: JSON.parse(JSON.stringify(this.itemInfo)),
          choiceSelected: JSON.parse(JSON.stringify(this.choiceSelected)),
          selectedSubCategoryIndex: index,
        };
        this.showSubCategoryModal = true;
      }
    },

    confirmSubCategoryModal() {
      this.showSubCategoryModal = false;
      this.subCategoryModalSnapshot = null;
      this.checkAvailableAddToCart();
    },

    cancelSubCategoryModal() {
      if (this.subCategoryModalSnapshot) {
        this.itemInfo = this.subCategoryModalSnapshot.itemInfo;
        this.choiceSelected = this.subCategoryModalSnapshot.choiceSelected;
        this.selectedSubCategoryIndex =
          this.subCategoryModalSnapshot.selectedSubCategoryIndex;
        this.subCategoryModalSnapshot = null;
        this.itemModifierKey = Math.random();
      }
      this.showSubCategoryModal = false;
      this.checkAvailableAddToCart();
    },

    addModifierOptionGroup(
      indexChoice = -1,
      index,
      index2,
      index3 = -1,
      index4 = -1
    ) {
      console.log(indexChoice);
      let modifierGroup = this.itemInfo.modifier_group[index];
      let modifierGroupItem = this.itemInfo.modifier_group[index].items[index2];
      // let parentModifierGroupItem = this.itemInfo.modifier_group[index].items[index2];
      let parentTotalSelectd = 1;

      if (index3 != -1) {
        parentTotalSelectd =
          this.itemInfo.modifier_group[index].items[index2].quantity ?? 1;;
        modifierGroup = this.itemInfo.modifier_group[index].items[index2]
          .item_in_mog.modifier_group[index3];
        modifierGroupItem = this.itemInfo.modifier_group[index].items[index2]
          .item_in_mog.modifier_group[index3].items[index4];
      }

      if (modifierGroup && modifierGroupItem) {
        if (
          modifierGroupItem.quantity < modifierGroupItem.item_max_qty &&
          modifierGroup.total_selected < modifierGroup.max_qty
        ) {
          modifierGroupItem.quantity += 1;
          this.itemInfo.member_price +=
            modifierGroupItem.price_default * parentTotalSelectd;
          this.itemInfo.price_default +=
            modifierGroupItem.price_default * parentTotalSelectd;
          modifierGroup.total_selected += 1;

          // if (index3 != - 1) {
          //   parentModifierGroupItem.price_default += modifierGroupItem.price_default;
          // }

          this.checkAvailableAddToCart();
        }
      }
    },

    addModifierOptionGroupChoice(
      indexChoice = -1,
      index,
      index2,
      index3 = -1,
      index4 = -1
    ) {
      let itemSelect = this.choiceSelected.items[indexChoice].item_detail;
      const itemChoiceQty = this.choiceSelected.items[indexChoice].qty;

      let modifierGroup = itemSelect.modifier_group[index];
      let modifierGroupItem = itemSelect.modifier_group[index].items[index2];
      // let parentModifierGroupItem = itemSelect.modifier_group[index].items[index2];
      let parentTotalSelectd = 1;

      if (index3 != -1) {
        parentTotalSelectd =
          itemSelect.modifier_group[index].items[index2].quantity ?? 1;;
        modifierGroup =
          itemSelect.modifier_group[index].items[index2].item_in_mog
            .modifier_group[index3];
        modifierGroupItem =
          itemSelect.modifier_group[index].items[index2].item_in_mog
            .modifier_group[index3].items[index4];
      }

      if (modifierGroup && modifierGroupItem) {
        if (
          modifierGroupItem.quantity < modifierGroupItem.item_max_qty &&
          modifierGroup.total_selected < modifierGroup.max_qty
        ) {
          modifierGroupItem.quantity += 1;
          this.itemInfo.member_price +=
            modifierGroupItem.price_default *
            parentTotalSelectd *
            itemChoiceQty;
          this.itemInfo.price_default +=
            modifierGroupItem.price_default *
            parentTotalSelectd *
            itemChoiceQty;
          modifierGroup.total_selected += 1;

          if (index3 == -1) {
            if (
              modifierGroupItem.item_in_mog &&
              modifierGroupItem.item_in_mog.modifier_group
            ) {
              modifierGroupItem.item_in_mog.modifier_group.forEach(
                (group) => {
                  group.items.forEach((itemModifier) => {
                    if (itemModifier.selected) {
                      this.itemInfo.price_default +=
                        itemModifier.price_default *
                        itemModifier.quantity *
                        itemChoiceQty;
                      this.itemInfo.member_price +=
                        itemModifier.price_default *
                        itemModifier.quantity *
                        itemChoiceQty;
                    }
                  });
                }
              );
            }
          }

          // if (index3 != - 1) {
          //   parentModifierGroupItem.price_default += modifierGroupItem.price_default;
          // }

          this.checkAvailableAddToCart();
        }
      }
    },

    removeModifierOptionGroup(
      // eslint-disable-next-line no-unused-vars
      indexChoice = -1,
      index,
      index2,
      index3 = -1,
      index4 = -1
    ) {
      // Get modifier group and item based on nesting level
      const parentItem = this.itemInfo.modifier_group[index].items[index2];
      const isNested = index3 !== -1;
      
      const modifierGroup = isNested
        ? parentItem.item_in_mog.modifier_group[index3]
        : this.itemInfo.modifier_group[index];
      
      const modifierGroupItem = isNested
        ? parentItem.item_in_mog.modifier_group[index3].items[index4]
        : this.itemInfo.modifier_group[index].items[index2];
      
      const parentTotalSelected = isNested ? (parentItem.quantity ?? 1) : 1;

      if (!modifierGroup || !modifierGroupItem) {
        return;
      }

      const currentQuantity = modifierGroupItem.quantity;
      const pricePerUnit = modifierGroupItem.price_default * parentTotalSelected;

      if (currentQuantity > 1) {
        // Decrement quantity
        modifierGroupItem.quantity -= 1;
        modifierGroup.total_selected -= 1;
        this.itemInfo.member_price -= pricePerUnit;
        this.itemInfo.price_default -= pricePerUnit;
      } else {
        // Uncheck modifier when quantity <= 1
        const totalPriceToDeduct = pricePerUnit * currentQuantity;
        
        modifierGroupItem.selected = false;
        modifierGroupItem.quantity = 1;
        modifierGroup.total_selected -= currentQuantity;
        this.itemInfo.member_price -= totalPriceToDeduct;
        this.itemInfo.price_default -= totalPriceToDeduct;

        // Handle nested modifiers for top-level items only
        if (!isNested && modifierGroupItem.item_in_mog?.modifier_group) {
          modifierGroupItem.item_in_mog.modifier_group.forEach((group) => {
            group.items.forEach((itemModifier) => {
              if (itemModifier.selected) {
                const nestedPrice = itemModifier.price_default * itemModifier.quantity * currentQuantity;
                itemModifier.selected = false;
                this.itemInfo.price_default -= nestedPrice;
                this.itemInfo.member_price -= nestedPrice;
              }
            });
          });
          modifierGroupItem.item_in_mog = {};
        }

        // Remove from items_selected array if exists
        if (modifierGroup.items_selected) {
          const targetIndex = isNested ? index4 : index2;
          const indexToRemove = modifierGroup.items_selected.indexOf(targetIndex);
          if (indexToRemove !== -1) {
            modifierGroup.items_selected.splice(indexToRemove, 1);
          }
        }
      }

      this.checkAvailableAddToCart();
    },

    removeModifierOptionGroupChoice(
      indexChoice = -1,
      index,
      index2,
      index3 = -1,
      index4 = -1
    ) {
      let itemSelect = this.choiceSelected.items[indexChoice].item_detail;
      const itemChoiceQty = this.choiceSelected.items[indexChoice].qty;

      // Determine context (nested or top-level)
      const parentItem = itemSelect.modifier_group[index].items[index2];
      const isNested = index3 !== -1;

      const modifierGroup = isNested
        ? parentItem.item_in_mog?.modifier_group?.[index3]
        : itemSelect.modifier_group[index];

      const modifierGroupItem = isNested
        ? parentItem.item_in_mog?.modifier_group?.[index3]?.items?.[index4]
        : itemSelect.modifier_group[index].items[index2];

      const parentTotalSelected = isNested ? (parentItem.quantity ?? 1) : 1;

      if (!modifierGroup || !modifierGroupItem) {
        return;
      }

      const currentQuantity = modifierGroupItem.quantity;
      const pricePerUnit =
        modifierGroupItem.price_default * parentTotalSelected * itemChoiceQty;

      if (currentQuantity > 1) {
        // Decrement quantity
        modifierGroupItem.quantity -= 1;
        modifierGroup.total_selected -= 1;
        this.itemInfo.member_price -= pricePerUnit;
        this.itemInfo.price_default -= pricePerUnit;
      } else {
        // Uncheck modifier when quantity <= 1
        const totalPriceToDeduct = pricePerUnit * currentQuantity;

        modifierGroupItem.selected = false;
        modifierGroupItem.quantity = 1;
        modifierGroup.total_selected -= currentQuantity;
        this.itemInfo.member_price -= totalPriceToDeduct;
        this.itemInfo.price_default -= totalPriceToDeduct;

        // Handle nested modifiers for top-level items only
        if (!isNested && modifierGroupItem.item_in_mog?.modifier_group) {
          modifierGroupItem.item_in_mog.modifier_group.forEach((group) => {
            group.items.forEach((itemModifier) => {
              if (itemModifier.selected) {
                const nestedPrice =
                  itemModifier.price_default *
                  itemModifier.quantity *
                  currentQuantity *
                  itemChoiceQty;
                itemModifier.selected = false;
                this.itemInfo.price_default -= nestedPrice;
                this.itemInfo.member_price -= nestedPrice;
              }
            });
          });
          modifierGroupItem.item_in_mog = {};
        }

        // Remove from items_selected array if exists
        if (modifierGroup.items_selected) {
          const targetIndex = isNested ? index4 : index2;
          const indexToRemove = modifierGroup.items_selected.indexOf(targetIndex);
          if (indexToRemove !== -1) {
            modifierGroup.items_selected.splice(indexToRemove, 1);
          }
        }
      }

      this.checkAvailableAddToCart();
    },

    selectOnlyItem(indexChoice = -1, index, index2, item, index3 = -1, index4 = -1) {
      console.log(indexChoice);
      let modifierGroup = this.itemInfo.modifier_group[index];
      let modifierGroupItem = this.itemInfo.modifier_group[index].items[index2];

      if (index3 == -1) {
        modifierGroup.items.forEach((item) => {
          item.is_show_modifier = false;
        })

        modifierGroupItem.is_show_modifier = !modifierGroupItem.is_show_modifier;
      } else {
        modifierGroup = this.itemInfo.modifier_group[index].items[index2].item_in_mog.modifier_group[index3];
        modifierGroupItem = this.itemInfo.modifier_group[index].items[index2].item_in_mog.modifier_group[index3].items[index4];
      }

      if (
        modifierGroup &&
        modifierGroupItem
      ) {
        if (!modifierGroupItem.is_not_available) {
          if (!modifierGroupItem.selected) {
            this.itemInfo.member_price +=
              modifierGroupItem.price_default *
              modifierGroupItem.quantity;
            this.itemInfo.price_default +=
              modifierGroupItem.price_default *
              modifierGroupItem.quantity;
          }

          modifierGroup.items.forEach(async (itemModifier, idx) => {
            if (idx != (index3 == -1 ? index2 : index4)) {
              if (itemModifier.selected) {
                this.itemInfo.member_price -= itemModifier.price_default * itemModifier.quantity;
                this.itemInfo.price_default -= itemModifier.price_default * itemModifier.quantity;

                if (itemModifier.item_in_mog && itemModifier.item_in_mog.modifier_group) {
                  itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                    subGroup.items.forEach((subItemModifier) => {
                        if (subItemModifier.selected) {
                          subItemModifier.selected = false;
                          this.itemInfo.member_price -= (subItemModifier.price_default * subItemModifier.quantity * itemModifier.quantity);
                          this.itemInfo.price_default -= (subItemModifier.price_default * subItemModifier.quantity * itemModifier.quantity);
                        }
                    });
                  })
                }

                modifierGroup.items[idx].quantity = 1;
              }
              itemModifier.selected = false;
            } else {
              if (!itemModifier.selected || item.first_load) {
                itemModifier.selected = true;

                // Skip re-fetching if item_in_mog is already populated — either
                // from a prior fetch in this session, or from MyCart's
                // restoreModifierGroup() restoring a previously-saved cart item's
                // selections when editing. The `first_load` re-trigger below
                // (ItemModifier.vue's keyReload watcher, which fires on every
                // modal open including edit) would otherwise unconditionally
                // overwrite that restored data with a fresh, all-unselected fetch.
                const existingItemInMog = modifierGroupItem.item_in_mog;
                const hasItemInMog = !!(existingItemInMog && existingItemInMog.id);
                if (index3 == -1 && !hasItemInMog) {
                  const fetchedItemInMog = await this.gotoOrderDetail(this.categoryId, item.id, item);
                  // Pre-existing forEach(async ...) pattern (not introduced here);
                  // a real fix means sequencing this loop, out of scope here.
                  // eslint-disable-next-line require-atomic-updates
                  modifierGroupItem.item_in_mog = fetchedItemInMog;
                }
              }
            }
          });

          // Sync group selection state for single (1/1) groups so that
          // addToCart() filter (which checks total_selected == 0) keeps the group
          // and items_selected reflects the actual selected index.
          modifierGroup.total_selected = 1;
          modifierGroup.items_selected = [index3 == -1 ? index2 : index4];
        }
      }
    },

    selectOnlyItemChoice(indexChoice = -1, index, index2, item, index3 = -1, index4 = -1) {
      let itemSelect = this.choiceSelected.items[indexChoice].item_detail;
      const itemChoiceQty = this.choiceSelected.items[indexChoice].qty;
      let modifierGroup = itemSelect.modifier_group[index];
      let modifierGroupItem = itemSelect.modifier_group[index].items[index2];

      if (index3 == -1) {
        modifierGroup.items.forEach((item) => {
          item.is_show_modifier = false;
        })

        modifierGroupItem.is_show_modifier = !modifierGroupItem.is_show_modifier;
      } else {
        modifierGroup = itemSelect.modifier_group[index].items[index2].item_in_mog.modifier_group[index3];
        modifierGroupItem = itemSelect.modifier_group[index].items[index2].item_in_mog.modifier_group[index3].items[index4];
      }

      if (
        modifierGroup &&
        modifierGroupItem
      ) {
        if (!modifierGroupItem.is_not_available) {
          if (!modifierGroupItem.selected) {
            this.itemInfo.member_price +=
              modifierGroupItem.price_default *
              modifierGroupItem.quantity *
              itemChoiceQty;
            this.itemInfo.price_default +=
              modifierGroupItem.price_default *
              modifierGroupItem.quantity *
              itemChoiceQty;
          }

          modifierGroup.items.forEach(async (itemModifier, idx) => {
            if (idx != (index3 == -1 ? index2 : index4)) {
              if (itemModifier.selected) {
                this.itemInfo.member_price -= itemModifier.price_default * itemModifier.quantity * itemChoiceQty;
                this.itemInfo.price_default -= itemModifier.price_default * itemModifier.quantity * itemChoiceQty;

                if (itemModifier.item_in_mog && itemModifier.item_in_mog.modifier_group) {
                  itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                    subGroup.items.forEach((subItemModifier) => {
                        if (subItemModifier.selected) {
                          subItemModifier.selected = false;
                          this.itemInfo.member_price -= (subItemModifier.price_default * subItemModifier.quantity * itemModifier.quantity * itemChoiceQty);
                          this.itemInfo.price_default -= (subItemModifier.price_default * subItemModifier.quantity * itemModifier.quantity * itemChoiceQty);
                        }
                    });
                  })
                }

                modifierGroup.items[idx].quantity = 1;
              }
              itemModifier.selected = false;
            } else {
              if (!itemModifier.selected || item.first_load) {
                itemModifier.selected = true;

                // See selectOnlyItem() — don't clobber item_in_mog already
                // restored from a saved cart item's selections when editing.
                const existingItemInMog = modifierGroupItem.item_in_mog;
                const hasItemInMog = !!(existingItemInMog && existingItemInMog.id);
                if (index3 == -1 && !hasItemInMog) {
                  const fetchedItemInMog = await this.gotoOrderDetail(this.categoryId, item.id, item, itemChoiceQty);
                  // See selectOnlyItem() above.
                  // eslint-disable-next-line require-atomic-updates
                  modifierGroupItem.item_in_mog = fetchedItemInMog;
                }
              }
            }
          });

          // Sync group selection state for single (1/1) groups so that
          // addToCart() filter (which checks total_selected == 0) keeps the group
          // and items_selected reflects the actual selected index.
          modifierGroup.total_selected = 1;
          modifierGroup.items_selected = [index3 == -1 ? index2 : index4];
        }
      }
    },
    async gotoOrderDetail(categoryId, id, item, itemChoiceQty = 1) {
      // console.log(stock_balance, is_not_available, stock_enable_balance, item)
      // if(this.checkAvailableItem(item) && item.isHaveModifierOptionGroups > 0) {
      let data = {};

      if(this.checkAvailableItem(item)) {
        this.categoryIdSelect = categoryId
        this.itemIdSelect = id;
        // this.showLoader();
        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId,
          item_id: id,
          branch_code: this.branch.branch_code ?? "",
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 0,
        };
        await OrderService.getItemDetail(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              if(response.data.data.modifier_group && response.data.data.modifier_group.length > 0) {
                data = response.data.data;
                this.itemInfo.price_default += (data.price_default - data.price_default_no_modifier_option) * itemChoiceQty;
                this.itemInfo.member_price += (data.price_default - data.price_default_no_modifier_option) * itemChoiceQty;
              }
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            // this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            // this.hideLoader();
          }
        );
      }

      return data;
    },
    async selectMultiItem(
      // eslint-disable-next-line no-unused-vars
      indexChoice = -1,
      index,
      index2,
      item,
      index3 = -1,
      index4 = -1
    ) {
      let modifierGroup = this.itemInfo.modifier_group[index];
      let modifierGroupItem = this.itemInfo.modifier_group[index].items[index2];
      let parentTotalSelectd = 1;

      if (index3 == -1) {
        modifierGroupItem.is_show_modifier = !modifierGroupItem.is_show_modifier;
      } else {
        parentTotalSelectd = this.itemInfo.modifier_group[index].items[index2].quantity ?? 1;
        modifierGroup = this.itemInfo.modifier_group[index].items[index2].item_in_mog.modifier_group[index3];
        modifierGroupItem = this.itemInfo.modifier_group[index].items[index2].item_in_mog.modifier_group[index3].items[index4];
      }

      if (modifierGroup && modifierGroupItem) {
        if (!modifierGroupItem.is_not_available) {
            if (!modifierGroupItem.selected && modifierGroup.total_selected >= modifierGroup.max_qty) {
              return;
            }

            modifierGroupItem.selected = !modifierGroupItem.selected;
            const modifierGroupItemQty = modifierGroupItem.quantity;

            if (modifierGroupItem.selected) {
              modifierGroup.total_selected += 1;
              this.itemInfo.member_price +=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd;
              this.itemInfo.price_default +=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd;

              // Add to items_selected if not already present
              const targetIndex = index3 == -1 ? index2 : index4;
              if (modifierGroup.items_selected && modifierGroup.items_selected.indexOf(targetIndex) === -1) {
                modifierGroup.items_selected.push(targetIndex);
              }

              if (index3 == -1) {
                modifierGroupItem.item_in_mog = await this.gotoOrderDetail(this.categoryId, item.id, item);
              }
            } else {
              modifierGroup.total_selected -= modifierGroupItemQty;
              this.itemInfo.member_price -=
                modifierGroupItem.price_default *
                modifierGroupItemQty * 
                parentTotalSelectd;
              this.itemInfo.price_default -=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd;
              
              if (index3 == -1) {
                if (modifierGroupItem.item_in_mog && modifierGroupItem.item_in_mog.modifier_group) {
                  modifierGroupItem.item_in_mog.modifier_group.forEach((group) => {
                    group.items.forEach((itemModifier) => {
                      if (itemModifier.selected) {
                        itemModifier.selected = false;
                        this.itemInfo.price_default -= itemModifier.price_default * itemModifier.quantity * modifierGroupItemQty;
                        this.itemInfo.member_price -= itemModifier.price_default * itemModifier.quantity * modifierGroupItemQty;
                      }
                    });
                  })
                }

                modifierGroupItem.item_in_mog = {};
              }

              modifierGroupItem.quantity = 1;
              
              // Remove from items_selected array
              const targetIndex = index3 == -1 ? index2 : index4;
              if (modifierGroup.items_selected) {
                const indexToRemove = modifierGroup.items_selected.indexOf(targetIndex);
                if (indexToRemove !== -1) {
                  modifierGroup.items_selected.splice(indexToRemove, 1);
                }
              }
            }

            this.checkAvailableAddToCart();
          }
      }
    },

    async selectMultiItemChoice(indexChoice = -1, index, index2, item, index3 = -1, index4 = -1) {
      let itemSelect = this.choiceSelected.items[indexChoice].item_detail;
      const itemChoiceQty = this.choiceSelected.items[indexChoice].qty;

      let modifierGroup = itemSelect.modifier_group[index];
      let modifierGroupItem = itemSelect.modifier_group[index].items[index2];
      let parentTotalSelectd = 1;

      if (index3 == -1) {
        modifierGroupItem.is_show_modifier = !modifierGroupItem.is_show_modifier;
      } else {
        parentTotalSelectd = itemSelect.modifier_group[index].items[index2].quantity ?? 1;
        modifierGroup = itemSelect.modifier_group[index].items[index2].item_in_mog.modifier_group[index3];
        modifierGroupItem = itemSelect.modifier_group[index].items[index2].item_in_mog.modifier_group[index3].items[index4];
      }
      

      if (modifierGroup && modifierGroupItem) {
        if (!modifierGroupItem.is_not_available) {
            if (!modifierGroupItem.selected && modifierGroup.total_selected >= modifierGroup.max_qty) {
              return;
            }

            modifierGroupItem.selected = !modifierGroupItem.selected;
            const modifierGroupItemQty = modifierGroupItem.quantity;

            if (modifierGroupItem.selected) {
              modifierGroup.total_selected += 1;
              this.itemInfo.member_price +=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd *
                itemChoiceQty;
              this.itemInfo.price_default +=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd *
                itemChoiceQty;

              // Add to items_selected if not already present
              const targetIndex = index3 == -1 ? index2 : index4;
              if (modifierGroup.items_selected && modifierGroup.items_selected.indexOf(targetIndex) === -1) {
                modifierGroup.items_selected.push(targetIndex);
              }

              if (index3 == -1) {
                modifierGroupItem.item_in_mog = await this.gotoOrderDetail(this.categoryId, item.id, item, itemChoiceQty);
              }
            } else {
              modifierGroup.total_selected -= modifierGroupItem.quantity;
              this.itemInfo.member_price -=
                modifierGroupItem.price_default *
                modifierGroupItemQty * 
                parentTotalSelectd *
                itemChoiceQty;
              this.itemInfo.price_default -=
                modifierGroupItem.price_default *
                modifierGroupItemQty *
                parentTotalSelectd *
                itemChoiceQty;
              
              if (index3 == -1) {
                if (modifierGroupItem.item_in_mog && modifierGroupItem.item_in_mog.modifier_group) {
                  modifierGroupItem.item_in_mog.modifier_group.forEach((group) => {
                    group.items.forEach((itemModifier) => {
                      if (itemModifier.selected) {
                        itemModifier.selected = false;
                        this.itemInfo.price_default -= itemModifier.price_default * itemModifier.quantity * modifierGroupItemQty * itemChoiceQty;
                        this.itemInfo.member_price -= itemModifier.price_default * itemModifier.quantity * modifierGroupItemQty * itemChoiceQty;
                      }
                    });
                  })
                }

                modifierGroupItem.item_in_mog = {};
              }

              modifierGroupItem.quantity = 1;
              
              // Remove from items_selected array
              const targetIndex = index3 == -1 ? index2 : index4;
              if (modifierGroup.items_selected) {
                const indexToRemove = modifierGroup.items_selected.indexOf(targetIndex);
                if (indexToRemove !== -1) {
                  modifierGroup.items_selected.splice(indexToRemove, 1);
                }
              }
            }

            this.checkAvailableAddToCart();
          }
      }
    },

    addItem() {
      this.itemInfo.quantity += 1;
    },

    removeItem() {
      this.itemInfo.quantity -= 1;
    },

    addToCart() {
      if (this.itemInfo.disable_add_to_cart) {
        // M899: this used to raise a browser alert naming the group, which on a
        // modal several screens tall still left the customer to find it. Jump to
        // the group instead. A sub-category item keeps its modifiers in a
        // separate modal, so there is no group to scroll to here — ring the row
        // whose modifiers are short, which is what the customer has to tap to
        // reopen them.
        if (this.itemInfo.is_sub_category) {
          scrollToFirstInvalid({
            selector:
              this.selectedSubCategoryIndex >= 0
                ? ".subcat-item.subcat-selected"
                : ".subcat-item",
            highlight: ".subcat-item",
          });
        } else {
          scrollToFirstInvalid({
            selector: ".select-min",
            highlight: ".accordion",
          });
        }
      } else {
        if (this.itemInfo.choice) {
          // Sub-category: only the single selected item goes into the cart payload.
          if (this.itemInfo.is_sub_category) {
            const idx = this.selectedSubCategoryIndex;
            if (idx >= 0 && this.choiceSelected.items[idx]) {
              this.choiceSelected.items = [this.choiceSelected.items[idx]];
            }
          }
          this.choiceSelected.items.forEach((item) => {
            let itemInfo = item.item_detail;
            let checkOrderSuccess = true;
            // let modifier_group_full = JSON.parse(JSON.stringify(itemInfo.modifier_group));

            // itemInfo.modifier_group_full = modifier_group_full;

            if (!itemInfo || !Array.isArray(itemInfo.modifier_group)) {
              return;
            }

            itemInfo.modifier_group.forEach((item) => {
              if (item.total_selected < item.min_qty) {
                checkOrderSuccess = false;
                return;
              }
            });

            if (!checkOrderSuccess) {
              return;
            }

            itemInfo.modifier_group = itemInfo.modifier_group.filter(
              (modifierGroup, index) => {
                if (modifierGroup.total_selected == 0) {
                  return false;
                } else {
                  itemInfo.modifier_group[
                    index
                  ].items = modifierGroup.items.filter((item) => {
                    if (!item.selected) {
                      return false;
                    }

                    if (item.item_in_mog && item.item_in_mog.modifier_group) {
                      item.item_in_mog.modifier_group = item.item_in_mog.modifier_group.filter(
                        (subModifierGroup, subIndex) => {
                          if (subModifierGroup.total_selected == 0) {
                            return false;
                          } else {
                            item.item_in_mog.modifier_group[
                              subIndex
                            ].items = subModifierGroup.items.filter((subItem) => {
                              if (!subItem.selected) {
                                return false;
                              }

                              return true;
                            });
                          }

                          return true;
                        }
                      )
                    }

                    return true;
                  });
                }

                return true;
              }
            );

            // itemInfo.modifier_group_full = itemInfo.modifier_group_full.filter(
            //   (modifierGroup, index) => {
            //     if (modifierGroup.total_selected == 0) {
            //       return false;
            //     } else {
            //       itemInfo.modifier_group_full[
            //         index
            //       ].items = modifierGroup.items.filter((itemMog) => {
            //         if (itemMog.selected) {
            //           return false;
            //         }

            //         return true;
            //       });
            //     }

            //     return true;
            //   }
            // );
          })

        } else {
          let checkOrderSuccess = true;
          //let modifier_group_full = JSON.parse(JSON.stringify(this.itemInfo.modifier_group));

          //this.itemInfo.modifier_group_full = modifier_group_full;

        if (Array.isArray(this.itemInfo.modifier_group)) {
          this.itemInfo.modifier_group.forEach((group) => {
            // Recalculate as the sum of selected quantities (not item count) to keep
            // total_selected consistent with the max_qty/min_qty checks elsewhere.
            const selectedQtySum = Array.isArray(group.items)
              ? group.items
                  .filter((it) => it.selected)
                  .reduce((sum, it) => sum + (it.quantity || 1), 0)
              : 0;

            // Sync total_selected if needed
            if (group.total_selected !== selectedQtySum) {
              group.total_selected = selectedQtySum;
            }

            if (selectedQtySum < group.min_qty) {
              checkOrderSuccess = false;
            }
          });
        }

          if (!checkOrderSuccess) {
            return;
          }

          this.itemInfo.modifier_group = (this.itemInfo.modifier_group || []).filter(
            (modifierGroup, index) => {
              if (modifierGroup.total_selected == 0) {
                return false;
              } else {
                this.itemInfo.modifier_group[
                  index
                ].items = modifierGroup.items.filter((item) => {
                  if (!item.selected) {
                    return false;
                  }

                  if (item.item_in_mog && item.item_in_mog.modifier_group) {
                      item.item_in_mog.modifier_group = item.item_in_mog.modifier_group.filter(
                        (subModifierGroup, subIndex) => {
                          if (subModifierGroup.total_selected == 0) {
                            return false;
                          } else {
                    item.item_in_mog.modifier_group[
                      subIndex
                    ].items = subModifierGroup.items.filter((subItem) => {
                      if (!subItem.selected) {
                        return false;
                      }

                            return true;
                          });
                        }

                        return true;
                      }
                    )
                  }

                  return true;
                });
              }

              return true;
            }
          );

          // this.itemInfo.modifier_group_full = this.itemInfo.modifier_group_full.filter(
          //   (modifierGroup, index) => {
          //     if (modifierGroup.total_selected == 0) {
          //       return false;
          //     } else {
          //       this.itemInfo.modifier_group_full[
          //         index
          //       ].items = modifierGroup.items.filter((item) => {
          //         if (item.selected) {
          //           return false;
          //         }

          //         return true;
          //       });
          //     }

          //     return true;
          //   }
          // );
        }

        this.itemInfo.choice_selected = this.choiceSelected;
        this.itemInfo.choices = null;

        // Step 5: Save category_id to itemInfo so it can be edited later
        this.itemInfo.category_id = this.categoryId;

        // Capture the fly-to-cart origin (modal food image) before the modal
        // closes, so Order.vue can animate the item into the cart pill.
        const flyPayload = this.getFlyPayload();

        // Step 4: Handle edit mode - if editing an item in the cart
        if (this.editMode && this.editItemIndex >= 0) {
          // Emit event to update item in cart instead of adding new
          this.$emit('item-updated', this.itemInfo);

          EventBus.emit("AddToCartSuccess");
          EventBus.emit("AddToCartThenReloadCategorySuccess", {time: this.reloadModal});
          EventBus.emit("FlyToCart", flyPayload);
          this.closeModel();
          return; // Stop here, don't execute normal add to cart logic
        }

        // Normal add to cart logic (when not in edit mode)
        let orderInfo =
          JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
        const objectInArrayIndex = orderInfo.findIndex(item => {
            if (this.compareObjects(item, this.itemInfo)) {
                item.quantity += this.itemInfo.quantity;
                return true;
            }
            return false;
        });
        if (objectInArrayIndex !== -1) {
          localStorage.removeItem(this.cartName);
          localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
        } else {
          orderInfo.push(this.itemInfo);
          localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
        }
        EventBus.emit("AddToCartSuccess");
        EventBus.emit("AddToCartThenReloadCategorySuccess", {time: this.reloadModal});
        EventBus.emit("FlyToCart", flyPayload);
        this.closeModel();
      }
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    clickLink(slide) {
      if(slide && slide.destination_link != "") {
        window.open(slide.destination_link);
      } else if(slide && slide.direct_to_menu_item != "" && !slide.direct_to_suggested_adds_on) {
        this.showLoader();
        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: this.categoryId ?? 0,
          item_id: slide.direct_to_menu_item ?? 0,
          branch_code: this.$store.state.branchCode,
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 0,
        };

        OrderService.getItemDetail(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.isLoadDone = true;
              this.imageError = false;
              this.itemInfo = response.data.data;
              this.itemInfo.price_default = parseFloat(this.itemInfo.price_default);
              this.itemInfo.member_price = parseFloat(this.itemInfo.member_price);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      }
    },

    calculateTotalStockBalanceForFoundItems(itemInfo) {
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      let totalStockBalance = 0;
      for (let item of orderInfo) {
        if (item.id === itemInfo.id) {
          totalStockBalance += item.quantity;
        }
      }
      return totalStockBalance;
    },

    calculateTotalStockBalanceForFoundItemsModifier(itemInfo) {
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      let totalStockBalance = 0;
      for (let i = 0; i < orderInfo.length; i++) {
          if (orderInfo[i] && orderInfo[i].modifier_group) {
              for (let j = 0; j < orderInfo[i].modifier_group.length; j++) {
                  if (orderInfo[i].modifier_group[j].items) {
                      for (let k = 0; k < orderInfo[i].modifier_group[j].items.length; k++) {
                          if (orderInfo[i].modifier_group[j].items[k].id === itemInfo.id) {
                              totalStockBalance += orderInfo[i].modifier_group[j].items[k].quantity;
                              // return;
                          }
                      }
                  }
              }
          }
      }
      return totalStockBalance;
    },

    checkAvailableItem() {
      const item = this.itemInfo;
      var stockBalance = this.itemInfo.stock_balance - this.calculateTotalStockBalanceForFoundItems(this.itemInfo);

      if(item.stock_enable_balance) { // countdown = true
          if(item.stock_balance > 0) {
              if(stockBalance > 0) {
                  return true;
              } else {
                  return false;
              }
          } else {
              return false;
          }
      } else { // countdown = false
          if(item.is_not_available == 0) {
            return true;
          } else {
              return false;
          }
      }
    },

    checkAvailableModifierItem(item) {
      var stockBalance = item.stock_balance - this.calculateTotalStockBalanceForFoundItemsModifier(item);
      if(item.stock_enable_balance) { // countdown = true
          if(item.stock_balance > 0) {
              if(stockBalance > 0) {
                  return false;
              } else {
                  return true;
              }
          } else {
              return true;
          }
      } else { // countdown = false
          if(item.is_not_available == 0) {
            return false;
          } else {
              return true;
          }
      }
    },

    // Ensure required groups (min_qty >=1, max_qty ==1) always have defaults if not selected
    ensureDefaultForRequiredGroups(modifierGroups) {
      if (!Array.isArray(modifierGroups)) return;

      modifierGroups.forEach((group) => {
        if (
          group &&
          group.min_qty >= 1 &&
          group.max_qty === 1 &&
          Array.isArray(group.items)
        ) {
          const hasSelected = group.items.some((it) => it.selected);

          if (!hasSelected) {
            const firstAvailableIndex = group.items.findIndex(
              (it) => !it.is_not_available
            );
            if (firstAvailableIndex !== -1) {
              group.items.forEach((it, idx) => {
                it.selected = idx === firstAvailableIndex;
                it.quantity = 1;
              });
              group.total_selected = 1;
              group.items_selected = [firstAvailableIndex];
            }
          }
        }
      });
    },

    checkAvailableAddToCart() {
      let check = false;

      if (this.itemInfo.is_sub_category) {
        // Keep price in sync with the selected item + its modifiers.
        this.recalcSubCategoryPrice();

        const idx = this.selectedSubCategoryIndex;
        const items = this.choiceSelected && this.choiceSelected.items;
        const sel = idx >= 0 && items && items[idx] ? items[idx].item_detail : null;

        if (!sel) {
          check = true;
        } else if (Array.isArray(sel.modifier_group)) {
          sel.modifier_group.forEach((group) => {
            const selectedQtySum = Array.isArray(group.items)
              ? group.items
                  .filter((it) => it.selected)
                  .reduce((sum, it) => sum + (it.quantity || 1), 0)
              : 0;

            group.total_selected = selectedQtySum;

            if (selectedQtySum < group.min_qty) {
              check = true;
            }
          });
        }

        this.itemInfo.disable_add_to_cart = check;
        return;
      }

      if (this.itemInfo.choice) {
        this.choiceSelected.items.forEach((item) => {
          let itemInfo = item.item_detail;

          if (!itemInfo || !Array.isArray(itemInfo.modifier_group)) {
            return;
          }

          itemInfo.modifier_group.forEach((group) => {
            const selectedQtySum = Array.isArray(group.items)
              ? group.items
                  .filter((it) => it.selected)
                  .reduce((sum, it) => sum + (it.quantity || 1), 0)
              : 0;

            // Sync total_selected with the total selected quantity (not item count),
            // so the max_qty/min_qty checks against total_selected stay consistent.
            group.total_selected = selectedQtySum;

            if (selectedQtySum < group.min_qty) {
              check = true;
            }
          });
        });
      } else if (Array.isArray(this.itemInfo.modifier_group)) {
        this.itemInfo.modifier_group.forEach((group) => {
          const selectedQtySum = Array.isArray(group.items)
            ? group.items
                .filter((it) => it.selected)
                .reduce((sum, it) => sum + (it.quantity || 1), 0)
            : 0;

          // Sync total_selected with the total selected quantity (not item count),
          // so the max_qty/min_qty checks against total_selected stay consistent.
          group.total_selected = selectedQtySum;

          if (selectedQtySum < group.min_qty) {
            check = true;
          }
        });
      }

      this.itemInfo.disable_add_to_cart = check;
    },
    compareObjects(obj1, obj2) {
      if (obj1.choice != obj2.choice) {
        return false;
      }

      // Check main item ID
      if (obj1.id !== obj2.id) {
          return false;
      }
      
      // Check main item price
      if (this.isLogined) {
        if (obj1.member_price != obj2.member_price) {
          return false;
        }
      } else {
        if (obj1.price_default != obj2.price_default) {
          return false;
        }
      }

      if (obj2.choice) {
        // Compare choice_selected
        if (!obj1.choice_selected || !obj2.choice_selected) {
          return false;
        }

        if (obj1.choice_selected.id !== obj2.choice_selected.id || obj1.choice_selected.default_price !== obj2.choice_selected.default_price || obj1.choice_selected.member_price !== obj2.choice_selected.member_price) {
          return false;
        }

        // Compare items in choice_selected
        const items1 = obj1.choice_selected.items || [];
        const items2 = obj2.choice_selected.items || [];

        if (items1.length !== items2.length) {
          return false;
        }

        for (let i = 0; i < items1.length; i++) {
          if (items1[i].id !== items2[i].id || items1[i].qty !== items2[i].qty) {
            return false;
          }

          let itemDetail1 = items1[i].item_detail;
          let itemDetail2 = items2[i].item_detail;

          // Compare modifiers in item
          if (itemDetail1?.modifier_group && itemDetail2?.modifier_group) {
            if (itemDetail1.modifier_group.length != itemDetail2.modifier_group.length) {
              return false;
            }
            
            for (let j = 0; j < itemDetail1.modifier_group.length; j++) {
              if (itemDetail1.modifier_group[j].id != itemDetail2.modifier_group[j].id || itemDetail1.modifier_group[j].total_selected != itemDetail2.modifier_group[j].total_selected) {
                return false;
              }
              
              let itemModifiers1 = itemDetail1.modifier_group[j].items;
              let itemModifiers2 = itemDetail2.modifier_group[j].items;

              if (itemModifiers1.length != itemModifiers2.length) {
                return false;
              }

              for (let k = 0; k < itemModifiers1.length; k++) {
                if (itemModifiers1[k].id != itemModifiers2[k].id || itemModifiers1[k].quantity != itemModifiers2[k].quantity) {
                  return false;
                }
              }
            }
          }
        }
      } else {
        // Compare items in modifier_group
        if (obj1.modifier_group.length !== obj2.modifier_group.length) {
            return false;
        }

        for (let i = 0; i < obj1.modifier_group.length; i++) {
            const group1 = obj1.modifier_group[i];
            const group2 = obj2.modifier_group[i];
            if (group1.items.length !== group2.items.length) {
                return false;
            }

            for (let j = 0; j < group1.items.length; j++) {
                if (group1.items[j].id !== group2.items[j].id || group1.items[j].quantity !== group2.items[j].quantity) {
                    return false;
                }
            }
        }
      }

      // All checks passed
      return true;
    },
    clearDataItem() {
      this.itemIdSelect = 0;
      // this.itemDetail = {};
    },
  },
  watch: {
    reloadModal() {
      setTimeout(() => {
        this.itemModifierKey = Math.random();
      }, 100);
      this.choiceSelected = {}
      this.selectedChoiceIndex = 0;
      this.imageError = false;

      if (this.itemId) {
        // Deep clone item data that has been restored modifiers by MyCart
        this.itemInfo = JSON.parse(JSON.stringify(this.itemDetail));

        if (this.itemInfo.choice) {
          // If editing in cart (already has choice_selected from MyCart)
          if (this.itemInfo.choice_selected && this.itemInfo.choice_selected.items) {
            // Find which choice index was previously selected by matching choice id or items
            let restoredIndex = 0;
            if (this.itemInfo.choices && this.itemInfo.choice_selected.id) {
              const foundIndex = this.itemInfo.choices.findIndex(
                (c) => c.id === this.itemInfo.choice_selected.id
              );
              if (foundIndex >= 0) restoredIndex = foundIndex;
            }

            // Use choices from API (already has modifier states restored by MyCart.restoreModifiersFromCart)
            // Do NOT replace with choice_selected — it only has selected modifiers, not the full list
            this.originalChoices = JSON.stringify(this.itemInfo.choices);

            this.selectedChoiceIndex = restoredIndex;
            this.choiceSelected = JSON.parse(JSON.stringify(this.itemInfo.choices[restoredIndex]));

            if (this.itemInfo.is_sub_category) {
              // Restore which single item was selected, then derive price from it.
              const savedItems = this.itemInfo.choice_selected.items || [];
              const savedId = savedItems.length ? savedItems[0].id : null;
              let selIdx = this.choiceSelected.items.findIndex(
                (it) => it.id === savedId
              );
              if (selIdx === -1) selIdx = 0;
              this.selectedSubCategoryIndex = selIdx;
              this.recalcSubCategoryPrice();
            } else {
              // Set base price from choice, then add selected modifier prices
              this.itemInfo.price_default_no_modifier_option = this.choiceSelected.default_price;
              this.itemInfo.price_default = parseFloat(this.choiceSelected.default_price);
              this.itemInfo.member_price_no_modifier_option = this.choiceSelected.member_price;
              this.itemInfo.member_price = parseFloat(this.choiceSelected.member_price);
              this.applyChoiceSchedule();
              this.recalcChoiceModifierPrice();

              // Highlight the correct tab after DOM renders
              this.$nextTick(() => {
                $('.choice-list > .choice-tab').removeClass('active');
                $('.choice-list > .choice-' + restoredIndex).addClass('active');
              });
            }
          } else {
            // If adding new from menu, use default selection as before
            this.originalChoices = JSON.stringify(this.itemInfo.choices);
            this.selectChoice(0);
          }
        } else {
          this.originalChoices = JSON.stringify(this.itemInfo.choices);
        }

        // When editing, if choice_selected already exists but some required groups haven't been selected,
        // apply defaults from API like the first add
        if (this.choiceSelected && this.choiceSelected.items) {
          this.choiceSelected.items.forEach((choiceItem) => {
            if (choiceItem.item_detail && choiceItem.item_detail.modifier_group) {
              this.ensureDefaultForRequiredGroups(
                choiceItem.item_detail.modifier_group
              );
            }
          });
        }

        if (this.itemInfo.slides) {
          var usedItems = [];
          this.itemInfo.slides.forEach(slide => {
            if (slide.direct_to_suggested_adds_on === 1 && Array.isArray(this.itemInfo.modifier_group)) {
              this.itemInfo.modifier_group.forEach(modifierGroup => {
                const selectedItem = modifierGroup.items.find(item => item.price > 0 && !usedItems.includes(item.id));
                if (selectedItem) {
                  usedItems.push(selectedItem.id)
                  slide.itemSelected = selectedItem;
                } else {
                  const selectedItemPriceIsZero = modifierGroup.items.find(item => item.price == 0 && !usedItems.includes(item.id));
                  if (selectedItemPriceIsZero) {
                    usedItems.push(selectedItemPriceIsZero.id)
                    slide.itemSelected = selectedItemPriceIsZero;
                  }
                }
              });
            }
          });
        }

        this.itemInfo.price_default = parseFloat(this.itemInfo.price_default);
        this.itemInfo.member_price = parseFloat(this.itemInfo.member_price);

        // Check if add to cart should be enabled after loading all data
        this.checkAvailableAddToCart();

        this.isLoadDone = true;
      } else {
        this.isLoadDone = false;
      }
    },
  },
};
</script>

<style scoped>
/* Css model */
/* Item-detail palette matched to the advocado reference (docs/design/10detailpage/code.html) */
.modal.modal-full {
  /* Surfaces = theme colour blended over white (opaque tints, no opacity stacking) */
  --d-surface: var(--theme-20, #fff8f7);
  --d-surface-low: var(--theme-30, #fef1ef);
  --d-surface-container: var(--theme-40, #f8ebea);
  --d-surface-high: var(--theme-40, #ece0de);
  /* Accent = the theme colour itself */
  --d-primary: var(--color);
  --d-primary-container: var(--color);
  --d-on-primary-container: #ffffff;
  --d-on-surface: #201a1a;
  --d-outline: #857372;
}

.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
  background: var(--theme-30, #f7f2ed);
}

/* Full Screen */
.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 480px;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.modal.modal-full .modal-content .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}

/* Hide the right scrollbar on the detail modal (scrolling still works) */
.modal.modal-full .modal-content,
.modal.modal-full .modal-content .modal-body {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.modal.modal-full .modal-content::-webkit-scrollbar,
.modal.modal-full .modal-content .modal-body::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

.modal.modal-full.fade .modal-dialog {
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 0.15s ease-out, transform 0.15s ease-out;
  will-change: opacity, transform;
}

.modal.modal-full.fade.show .modal-dialog {
  opacity: 1;
  transform: scale(1);
}

.modal.modal-full.fade .modal-dialog {
  bottom: 0;
}

.btn-close-modal {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  left: max(20px, calc(50% - 240px + 20px));
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  transition: transform 0.15s ease;
  z-index: 999999
}

.btn-close-modal:active {
  transform: scale(0.9);
}

.btn-close-modal div {
  font-size: 30px !important;
  font-weight: 400;
  color: var(--color) !important;
  padding-right: 0 !important;
  margin-bottom: 3px;
}

/* CSS item detail */
.page-header {
  position: relative;
  background: var(--theme-30, #f7f2ed);
  height: unset !important;
  overflow-y: unset !important;
  padding-bottom: 0 !important;
}

.page-header .container {
  padding: 0 !important;
}

.page-header .container .content {
  margin-bottom: 110px;
}

.content-sheet {
  position: relative;
  z-index: 2;
  margin-top: -28px;
  padding-top: 28px;
  padding-bottom: 4px;
  background: var(--theme-30, #f7f2ed);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.content-sheet .item-name:first-child {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.content-sheet .item-name span {
  font-size: 20px !important;
  font-weight: 700;
}

.detail-divider {
  height: 1px;
  background: var(--moo-outline, #f1f1f1);
  margin: 20px 1em 4px;
}

.food-image--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--moo-surface-muted, #f1f1f1);
  animation: none;
}

.food-image__placeholder-icon {
  font-size: 64px;
  color: var(--moo-disabled, #bdbdbd);
}

.item-img-cont {
  position: relative;
  max-height: 590px !important;
}

.item-img-container .btn-back {
  position: absolute;
  top: 5px;
  left: 0px;
  cursor: pointer;
}

.item-img-container img {
  width: 100%;
  height: auto;
  max-height: 400px;
}

.item-img-container .item-name {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #201a1a;
  font-family: 'Inter', sans-serif;
}

/* Header price (right-aligned span in the title row) reads as a bold accent */
:deep(.item-img-container > .mt-3 .item-name span) {
  font-size: 18px !important;
  font-weight: 800;
}

/* Choice-item titles are secondary to the main dish title */
:deep(.item-list .item-detail .item-name) {
  font-size: 16px !important;
  font-weight: 700;
}
:deep(.item-list .item-detail .item-name span) {
  font-size: 14px !important;
}

:deep(.signature-highlight) {
  display: inline-flex !important;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: var(--color);
  height: auto;
  flex-shrink: 0;
}

:deep(.signature-highlight div) {
  font-size: 10px !important;
  line-height: 13px;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  white-space: nowrap;
}

:deep(.signature-highlight i) {
  font-size: 11px;
  margin-top: 3px;
}

:deep(.highlight-banner) {
  display: flex;
  width: 100% !important;
  overflow-x: auto;
  padding: 12px 24px;
  background-color: var(--moo-highlight-bg, #fcf1f9);
}

:deep(.highlight-banner img) {
  min-width: 100%;
  height: 100px;
}

:deep(.highlight-banner div:not(:first-child)) {
  padding-left: 15px;
}

:deep(.accordion > div:first-child) {
  padding-bottom: 5px;
}

:deep(.accordion > div) {
  cursor: pointer;
}

:deep(.accordion .option-item) {
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  margin-top: 8px;
  padding: 14px 16px;
  border-radius: 16px;
  background: var(--theme-option, #f2ebe3);
  border: 1.5px solid transparent;
  transition: border-color 0.15s ease, background 0.15s ease;
}

/* Selected option: light brand-tinted fill + border, matching the Advocado
   card treatment (subtle, no harsh shadow). */
:deep(.accordion .option-item:has(.form-check-input:checked)) {
  background: var(--theme-20, #eef4e8);
  border-color: var(--color);
}

/* --- Nested item_in_mog modifiers (revealed under a selected option) --- */
/* They render inside the parent option card; show them as clean, lightly
   indented flat rows under an "Add modifier" divider instead of stacking
   cards-within-cards (which broke the layout). */
:deep(.option-item .mt-1.ms-3) {
  margin: 12px 0 0 0 !important;
  padding-top: 10px;
  border-top: 1px dashed var(--theme-40, rgba(133, 115, 114, 0.28));
}

/* "Add modifier" label */
:deep(.option-item .mt-1.ms-3 > div:first-child) {
  font-size: 12px;
  font-weight: 700;
  color: var(--moo-text-muted, #666666);
  margin-bottom: 2px;
}

/* Nested accordion: drop the extra side padding so rows align with the parent */
:deep(.option-item .mt-1.ms-3 .accordion) {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 8px !important;
  padding-bottom: 4px !important;
}

/* Nested option rows: flat (no card fill/border/radius), tighter spacing */
:deep(.option-item .option-item) {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 8px 4px !important;
  margin-top: 0 !important;
}

:deep(.option-item .option-item + .option-item) {
  border-top: 1px solid var(--theme-40, rgba(133, 115, 114, 0.14)) !important;
}

/* Kill Bootstrap's negative row gutter on nested rows so their content stays
   aligned under the group header instead of overflowing to the left. */
:deep(.option-item .option-item .row) {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

:deep(.accordion .modifierGroupName) {
  font-size: 17px !important;
  font-weight: 700;
  color: #201a1a;
  line-height: 1.25;
}

/* Group header (Advocado layout): title + check on the first line, the
   "Select N" hint stacked beneath it, and the Optional/Compulsory tag pinned
   to the right and vertically centred. */
:deep(.accordion .justify-content-between > div:first-child) {
  flex-wrap: wrap;
  row-gap: 3px;
  align-items: center;
  min-width: 0;
}
:deep(.accordion .justify-content-between > div:first-child > .modifierGroupName) {
  order: 0;
}
:deep(.accordion .justify-content-between > div:first-child > .icon-check) {
  order: 1;
}
:deep(.accordion .justify-content-between > div:first-child > .d-flex.me-2) {
  order: 2;
  flex: 0 0 100%;
  margin: 0 !important;
}
:deep(.accordion .justify-content-between > div:first-child > .d-flex.me-2 .fs-11) {
  margin: 0 !important;
}

:deep(.accordion .option-item > div:first-child) {
  padding-right: 0;
}

:deep(.accordion .option-item .row) {
  position: relative;
  z-index: 1;
  margin: 0;
  width: 100%;
  align-items: center;
}

:deep(.accordion .option-item .col-8),
:deep(.accordion .option-item .col-4) {
  padding-left: 0;
  padding-right: 0;
}

/* Round checkboxes (like radios) inside the modifier options */
:deep(.option-item input.form-check-input[type="checkbox"]) {
  border-radius: 50% !important;
}


:deep(.accordion .option-item i),
:deep(.total-item i) {
  font-size: 18px;
  font-weight: bold;
}

:deep(.accordion .option-item i) {
  color: var(--color);
}

:deep(.accordion .option-item .item-quantity),
:deep(.total-item .item-quantity) {
  width: 27px;
  text-align: center;
  border-radius: 8px;
  background: radial-gradient(
    343px at 46.3% 47.5%,
    rgb(242, 242, 242) 0%,
    rgb(241, 241, 241) 72.9%
  );
  padding: 4px 2px;
  margin: 0 3px;
  border: none;
}

/* Inner qty chip on a selected option: clean white chip instead of the grey
   radial box, so it sits nicely on the tinted card. */
:deep(.accordion .option-item .item-quantity) {
  background: #ffffff;
  font-weight: 700;
  color: #201a1a;
  padding: 3px 2px;
  margin: 0 4px;
}

.total-item {
  height: 48px;
  display: flex;
  align-items: center;
  background: var(--theme-20, #ece3d9);
  border-radius: 999px;
  padding: 0 6px;
}

:deep(.total-item .item-quantity) {
  font-size: 18px;
  width: 30px;
  font-weight: 700;
  margin: 0;
  background: transparent;
  font-family: 'Inter', sans-serif;
}

:deep(.total-item i) {
  font-size: 22px;
  color: var(--color);
}

.add-to-cart {
  position: fixed;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99999;
  width: 100%;
  max-width: 480px;
  border-radius: 32px 32px 0 0;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.06);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--theme-30, #f7f2ed);
  padding-top: 16px;
  padding-bottom: 26px;
  padding-left: 14px;
  padding-right: 14px;
}

.btn-add-to-cart {
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-transform: unset !important;
  background-color: var(--color) !important;
  border-color: var(--color) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14) !important;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  padding: 0 16px !important;
  margin: 0 !important;
  border-radius: 999px;
  border: 1px solid var(--color) !important;
  color: #fff !important;
}

.btn-add-to-cart__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Inter', sans-serif;
}

.btn-add-to-cart__total {
  flex-shrink: 0;
  font-weight: 700;
  white-space: nowrap;
  font-family: 'Inter', sans-serif;
}

.btn-add-to-cart.disable {
  background: var(--theme-20, #e8e0d8) !important;
  border-color: transparent !important;
  box-shadow: none !important;
  color: #a79e95 !important;
}

:deep(.break-line) {
  width: auto;
  height: 1px;
  background-color: var(--theme-40, rgba(133, 115, 114, 0.18));
  margin: 10px 1em;
}

:deep(.fs-18) {
  font-size: 16px !important;
}

:deep(.fs-16) {
  font-size: 16px !important;
}

:deep(.fs-13) {
  font-size: 13px !important;
}

:deep(.fs-11) {
  font-size: 11px !important;
}

:deep(.select-min) {
  font-weight: 500;
  color: var(--moo-error, #eb2f06) !important;
}

:deep(.disabled-item) {
  opacity: 0.5;
}

:deep(.item-img-container .item-description) {
  font-size: 14.5px !important;
  line-height: 1.4;
  color: var(--moo-text-muted, #666666) !important;
  font-family: 'Inter', sans-serif;
}

:deep(.item-img-container .txt-from) {
  font-size: 11px !important;
  color: gray !important;
  font-family: 'Inter', sans-serif;
}

:deep(.modifierGroupName) {
  font-family: 'Inter', sans-serif;
}

:deep(.modifierGroupSignature) {
  font-family: 'Inter', sans-serif;
}

:deep(.font-inter) {
  font-family: 'Inter', sans-serif;
  color: var(--moo-text-muted, #666666);
}

:deep(.font-inter-and-selected) {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: var(--moo-text-muted, #666666);
}

:deep(.font-inter-and-not-selected) {
  font-family: 'Inter', sans-serif;
  font-weight: normal;
  color: var(--moo-text-muted, #666666) !important;
}

:deep(.item-image) {
  height: 300px;
  width: auto;
  overflow: hidden;
  background-size: cover;
  background-position: center bottom;
  transition: transform 3s ease;
  transform-origin: center;
}

:deep(.icon-check) {
  display: inline-block;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('~@/assets/img/my-cart/icon-check-green.svg');
  width: 16px;
  height: 16px;
}

:deep(.item-name-top) {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 480px;
  left: 50%;
  transform: translateX(-50%);
  height: 56px;
  z-index: 99999;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: saturate(180%) blur(18px);
  -webkit-backdrop-filter: saturate(180%) blur(18px);
  font-weight: 700;
  opacity: 0;
  padding-left: 70px;
  padding-right: 30px;
  box-shadow: 0 2px 6px 0 rgba(28,28,28,.08);
}

:deep(.item-name-top.active) {
  opacity: 1;
  transition: opacity .2s;
}

:deep(.item-name-top > div) {
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.pad-left-right) {
  padding-left: 1em; 
  padding-right: 1em;
}

.schedule-struck {
  line-height: normal;
  font-size: 12px;
  color: var(--moo-muted, #9e9e9e);
  text-decoration: line-through;
}

:deep(.modifier-not-available) {
  opacity: 0.5 !important;
}

:deep(.modifier-not-available > div > span:first-child) {
  text-decoration: line-through !important;
}

:deep(.image-container) {
  width: 100%;
  height: auto;
  max-height: 400px;
  overflow: hidden;
  position: relative;
  border-radius: 0;
  background: var(--theme-20, #ece3dd);
}

/* Fixed 380px hero only for the main item detail (not the sub-category modal) */
:deep(.page-header .image-container) {
  height: 380px;
  max-height: none;
}

:deep(.food-image) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: zoomOut 1.5s ease-out forwards;
}

:deep(.choice-list) {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  text-align: center;
}

:deep(.choice-list > .choice-tab) {
  flex: 0 0 auto;
  padding: 8px 20px;
  color: var(--moo-text-muted, #666666);
  border-radius: 22px;
  border: 1px solid var(--moo-outline, #e0e0e0);
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  transition: all 0.15s ease-in-out;
}

:deep(.choice-list > .choice-tab.active) {
  background-color: var(--color);
  color: var(--moo-on-primary, #ffffff);
  border: 1px solid var(--color);
}

/* Content sheet rises over the image's bottom edge with a rounded top,
   mirroring the reference design. */
:deep(.item-img-container > .image-container + .mt-3) {
  position: relative;
  z-index: 1;
  margin-top: -26px !important;
  padding-top: 24px;
  border-radius: 24px 24px 0 0;
  background: var(--theme-30, #f7f2ed);
}

/* Modifier checkboxes follow the merchant theme when checked. */
:deep(.option-item .form-check-input[type="checkbox"]) {
  border-radius: 6px;
  border: 1.5px solid var(--theme-40, #cdc3b8);
  background-color: #ffffff;
}

:deep(.option-item .form-check-input[type="checkbox"]:checked) {
  background-color: var(--color);
  border-color: var(--color);
}

/* Sub-category single-select rows */
:deep(.subcat-item) {
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: all 0.15s ease-in-out;
}

:deep(.subcat-item.subcat-selected) {
  border: 1px solid var(--color);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}

:deep(.subcat-mod-summary) {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--moo-outline-variant, #e0e0e0);
}

:deep(.subcat-mod-line) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: var(--moo-text-muted, #666666);
  font-family: "Inter", sans-serif;
  padding: 2px 0;
}

:deep(.subcat-mod-line.nested) {
  padding-left: 16px;
  font-size: 12px;
  color: var(--moo-text-faint, #999999);
}

:deep(.subcat-mod-price) {
  white-space: nowrap;
  color: var(--color);
}

/* --- Modifier-group header inside the sub-category modal only --- */
:deep(.subcat-modal-body .accordion) {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

/* Header row: everything on ONE line, vertically centered */
:deep(.subcat-modal-body .accordion > div:first-child > .d-flex:first-child) {
  align-items: center !important;
  flex-wrap: nowrap;
  column-gap: 10px;
  width: 100%;
}

/* Left cluster (name + "Select N"): shrinks so the badge stays on the row */
:deep(.subcat-modal-body .accordion > div:first-child > .d-flex:first-child > div:first-child) {
  align-items: center !important;
  column-gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
}

/* "Select N" hint keeps its size, never wraps */
:deep(.subcat-modal-body .accordion .d-flex.me-2) {
  flex-shrink: 0;
}

/* Kill the vertical offset so "Select N" lines up with the name */
:deep(.subcat-modal-body .fs-11.mt-1) {
  margin-top: 0 !important;
}

/* Name shrinks + ellipsis instead of pushing the badge down */
:deep(.subcat-modal-body .modifierGroupName) {
  font-size: 15px !important;
  line-height: 1.3;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Badge: right side, centered, never squished */
:deep(.subcat-modal-body .signature-highlight) {
  flex-shrink: 0;
  white-space: nowrap;
  align-self: center;
  margin-left: auto;
}

@keyframes zoomOut {
  0% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 480px) {
  :deep(.image-container) {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
  :deep(.page-header .image-container) {
    height: 380px;
    aspect-ratio: auto;
  }
}
</style>
